import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChangelogItem } from '@shared/index';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChangeLogService {
  public changeLog: ChangelogItem[] = [];
  constructor(public http: HttpClient) { }

  public async loadChangeLogs(botId: string) {
    this.changeLog = await firstValueFrom(this.http.get<ChangelogItem[]>("/api/toolbox/bot/admin/changelog/" + botId));
  }
}